import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Input, Button, Col, Row, Select, DatePicker } from "antd";
import styled from "styled-components";
import { useHistory, useParams } from "react-router-dom";
import Auxiliary from "util/Auxiliary";
import ModuleBreadcrumb from "components/Common/ModuleBreadcrumb";
import AppForm from "components/Common/AppForm";
import {
  requestUserAdd,
  requestUserDetailById,
  requestUserEdit,
} from "../../../appRedux/actions/User";
import { getuserdetailSelector } from "../../../appRedux/selectors/User";
import { useEffect } from "react";
import moment from "moment";

const { Option } = Select;
const { TextArea } = Input;

const Adddatabse = () => {
  const [form] = Form.useForm();
  const params = useParams();
  const editedUser = useSelector(getuserdetailSelector);
  const dispatch = useDispatch();
  const history = useHistory();

  // Give a flag is in EDIT mode or not
  const isEdit = useMemo(() => {
    if (params && params.id) {
      return true;
    }
    return false;
  }, [params]);

  useEffect(() => {
    if (isEdit) {
      dispatch(requestUserDetailById(params.id));
    }
  }, []);

  useEffect(() => {
    if (isEdit && editedUser) {
      form.setFieldsValue({
        user_name: editedUser?.user_name,
        birthdate: moment(editedUser?.birthdate),
        address: editedUser?.address,
        mobile: editedUser?.mobile,
        standard: editedUser?.standard,
      });
    } else {
      form.resetFields();
    }
  }, [editedUser, isEdit, form]);

  const onSubmitFormHandler = async (values) => {
    const userData = {
      ...values,
      birthdate: values?.birthdate.format("DD-MM-YYYY"),
    };
    if (isEdit) {
      dispatch(
        requestUserEdit({
          data: userData,
          id: params.id,
        })
      );
    } else {
      dispatch(requestUserAdd(userData));
    }
  };

  return (
    <DatabaseStyle>
      <Auxiliary>
        <ModuleBreadcrumb
          title="Nikol Bal-Sabha Database"
          breadcrumbs={["Database", isEdit ? "Edit" : "Add"]}
          links={["/database", "/database", ""]}
        />
        <Row className="gx-profile-content">
          <Col span={24}>
            <div className="gx-card">
              <div className="gx-card-body">
                <AppForm
                  className="app-forms"
                  // layout="vertical"
                  scrollToFirstError={{
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest",
                  }}
                  onFinish={onSubmitFormHandler}
                  form={form}
                >
                  <Row>
                    <Col span={24} lg={12} xl={12}>
                      <Form.Item
                        label="Name"
                        name="user_name"
                        rules={[
                          {
                            required: true,
                            message: "Name is required!",
                          },
                        ]}
                      >
                        <Input placeholder="Name" />
                      </Form.Item>
                    </Col>
                    <Col span={24} lg={12} xl={12}>
                      <Form.Item label="Phone Number" name="mobile">
                        <Input placeholder="Phone Number" />
                      </Form.Item>
                    </Col>
                    <Col span={24} lg={12} xl={12}>
                      <Form.Item label="Address" name="address">
                        <TextArea rows={4} placeholder="Address" />
                      </Form.Item>
                    </Col>
                    <Col span={24} lg={12} xl={12}>
                      <Form.Item
                        label="Birth Date"
                        name="birthdate"
                        className="pwd-field remove-colon"
                      >
                        <DatePicker
                          placeholder="Birth Date"
                          format="DD-MM-YYYY"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24} lg={12} xl={12}>
                      <Form.Item
                        label="Standard"
                        name="standard"
                        className="pwd-field remove-colon"
                      >
                        <Select
                          allowClear
                          placeholder="Standard"
                          style={{
                            width: "100%",
                          }}
                        >
                          <Option value="jr_kg">Junior Kg</Option>
                          <Option value="sr_kg">Senior Kg</Option>
                          <Option value="1">1</Option>
                          <Option value="2">2</Option>
                          <Option value="3">3</Option>
                          <Option value="4">4</Option>
                          <Option value="5">5</Option>
                          <Option value="6">6</Option>
                          <Option value="7">7</Option>
                          <Option value="8">8</Option>
                          <Option value="9">9</Option>
                          <Option value="10">10</Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    {/* <Col span={24} lg={12} xl={12}>
                      <Form.Item label="Skills" name="skill">
                        <Select
                          allowClear
                          placeholder="Skills"
                          style={{
                            width: "100%",
                          }}
                        >
                          <Option value="decoration">Decoration</Option>
                          <Option value="cleanning">Cleanning</Option>
                          <Option value="speech">Speech</Option>
                          <Option value="parking_seva">Parking Seva</Option>
                          <Option value="other">Other</Option>
                        </Select>
                      </Form.Item>
                    </Col> */}
                  </Row>
                  <div className="gx-text-center gx-pt-3">
                    <Form.Item>
                      <Button
                        className="gx-mb-0"
                        onClick={() => history.push("/database/view")}
                        style={{ padding: "0 24px" }}
                      >
                        Cancel
                      </Button>
                      <Button
                        className="gx-mb-0"
                        type="primary"
                        htmlType="submit"
                        style={{ padding: "0 27px" }}
                      >
                        Save
                      </Button>
                    </Form.Item>
                  </div>
                </AppForm>
              </div>
            </div>
          </Col>
        </Row>
      </Auxiliary>
    </DatabaseStyle>
  );
};

export default Adddatabse;

const DatabaseStyle = styled.div`
  .phone-number {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-weight: 600;
  }
  .plus-icon {
    font-size: 25px;
    margin-left: 15px;
    display: flex;
    align-items: center;
  }
  .remove-btn {
    background: rgb(230, 68, 60);
    border-radius: 25px;
    color: rgb(255, 255, 255);
    text-transform: uppercase;
    margin-top: 15px;
    &:hover {
      background: rgb(230, 68, 60);
      color: rgb(255, 255, 255);
      border: rgb(230, 68, 60);
    }
  }
  .logo {
    width: 235px;
    height: 235px !important;
    border-radius: 6px;
    margin-top: 10px;
  }
  .ant-radio-inner::after {
    top: 10.5px;
    left: 11px;
  }
  .platform-select
    .ant-select:not(.ant-select-customize-input)
    .ant-select-selector {
    border-radius: 6px !important;
    height: 36px;
    align-items: center;
  }
  .ant-form-item-row {
    flex-direction: column !important;
  }
  .ant-form-item-label {
    text-align: left !important;
  }
  .ant-form-horizontal .ant-row {
    margin-left: -10px;
    margin-right: -10px;
  }
`;
